import { Mail, Phone } from 'lucide-react';
import { CONTACT_EMAIL, CONTACT_PHONE, telHref } from '../config/site';

/** "Contact us" paragraph for legal/help pages, using the configured details. */
export const ContactDetails = ({ topic = 'this page' }) => (
  <div className="text-gray-700 leading-relaxed space-y-3">
    <p>If you have any questions about {topic}, please contact us:</p>
    {(CONTACT_EMAIL || CONTACT_PHONE) ? (
      <ul className="space-y-2">
        {CONTACT_EMAIL && (
          <li className="flex items-center gap-2">
            <Mail className="h-4 w-4 text-gold" aria-hidden="true" />
            <a href={`mailto:${CONTACT_EMAIL}`} className="text-ink underline underline-offset-2 hover:text-gold">{CONTACT_EMAIL}</a>
          </li>
        )}
        {CONTACT_PHONE && (
          <li className="flex items-center gap-2">
            <Phone className="h-4 w-4 text-gold" aria-hidden="true" />
            <a href={telHref(CONTACT_PHONE)} className="text-ink underline underline-offset-2 hover:text-gold">{CONTACT_PHONE}</a>
          </li>
        )}
      </ul>
    ) : (
      <p>You can also text HELP to our ordering number and describe your question.</p>
    )}
  </div>
);
